<template>
  <el-table
    :data="tableData"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      v-if="sellerDimension == 1"
      prop="brandsName"
      label="会员体系"
      align="center"
    />
    <el-table-column prop="platformName" label="平台" align="center" />
    <el-table-column prop="sellerName" label="店铺名称" align="center" />
    <el-table-column
      prop="attractionCount"
      label="认知、吸引期会员"
      align="center"
    />
    <el-table-column prop="introduceCount" label="引入期客户" align="center" />
    <el-table-column prop="longTermCount" label="成长期客户" align="center" />
    <el-table-column prop="matureCount" label="成熟期客户" align="center" />
    <el-table-column prop="declineCount" label="衰退期客户" align="center" />
    <el-table-column prop="lossCount" label="流失期客户" align="center" />
    <el-table-column prop="totalCount" label="全部客户" align="center" />
  </el-table>
</template>

<script>
import mixins from "../../mixins/index.js";
import Empty from "../../components/empty.vue";
export default {
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
  computed: {
    countTable() {
      return this.tableData;
    },
    sellerDimension() {
      if (
        this.tableData &&
        this.tableData.length > 0 &&
        this.tableData[0].brandsName
      ) {
        return 1;
      }
      return 0;
    },
  },
  methods: {
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      const isSamePlatformSeller =
        row.platformName &&
        row.sellerName &&
        row.platformName === row.sellerName;

      if (this.sellerDimension == 1) {
        if (isSamePlatformSeller) {
          if (columnIndex === 1) {
            return {
              rowspan: 1,
              colspan: 2,
            };
          }
          if (columnIndex === 2) {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }

        if (columnIndex === 0) {
          const current = row.brandsName;
          const prev = this.countTable[rowIndex - 1] ? this.countTable[rowIndex - 1].brandsName : null;
          if (current && current === prev) {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.countTable.length; i++) {
            const nextRow = this.countTable[i] ? this.countTable[i].brandsName : null;
            if (nextRow === current) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan,
            colspan: 1,
          };
        }

        if (columnIndex === 1) {
          const currentPlatform = row.platformName;
          const currentBrand = row.brandsName;
          const prev = this.countTable[rowIndex - 1];
          if (
            prev &&
            prev.brandsName === currentBrand &&
            prev.platformName === currentPlatform
          ) {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.countTable.length; i++) {
            let brandsName = this.countTable[i] ? this.countTable[i].brandsName : null;
            let platformName = this.countTable[i] ? this.countTable[i].platformName : null;
            if (
              brandsName === currentBrand &&
              platformName === currentPlatform
            ) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan,
            colspan: 1,
          };
        }
      }

      if (isSamePlatformSeller) {
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 2,
          };
        }
        if (columnIndex === 1) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }

      if (columnIndex === 0) {
        const current = row.platformName;
        const prev = this.countTable[rowIndex - 1] ? this.countTable[rowIndex - 1].platformName : null;
        if (current && current === prev) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.countTable.length; i++) {
          const nextRow = this.countTable[i] ? this.countTable[i].platformName : null;
          if (nextRow === current) {
            rowspan++;
          } else {
            break;
          }
        }
        return {
          rowspan,
          colspan: 1,
        };
      }
    },
  },
};
</script>
